import {createSlice} from '@reduxjs/toolkit';
// let counter = 0;

// async function wait(ms) {
//     return new Promise((resolve) => {
//         // setTimeout(resolve, ms)
//     })
// }

const creditGuardBlockSlice = createSlice({
  name: 'creditGaurd',
  initialState: 0,
  reducers: {
    increment: (state, action) => {
      return ++state;
    },
    decrement: (state, action) => {
      return --state;
    },
    setRandom: {
      reducer(state, action) {
        const {randomNumber} = action.payload;
        return randomNumber;
      },
      prepare() {
        return {payload: {randomNumber: Math.random() * 100}};
      },
    },
  },
});

//Test

export const {increment, decrement, setRandom} = creditGuardBlockSlice.actions;

export default creditGuardBlockSlice.reducer;
